import React from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Link } from 'react-router-dom';

const h2Style = {fontSize: '1.75rem', color: '#111827', marginTop: '3rem', marginBottom: '1.25rem', fontWeight: '700', paddingBottom: '0.5rem', borderBottom: '2px solid #dc2626'};
const h3Style = {fontSize: '1.2rem', color: '#111827', marginTop: '1.5rem', marginBottom: '0.75rem', fontWeight: '600'};
const pStyle = {marginBottom: '1rem', color: '#374151', lineHeight: '1.8'};
const ulStyle = {marginLeft: '2rem', marginBottom: '1.5rem'};
const liStyle = {marginBottom: '0.75rem', color: '#374151', lineHeight: '1.7'};

const TermsPage = () => {
  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="terms-hero" style={{background: '#dc2626', backgroundColor: '#dc2626', paddingTop: '166px', paddingBottom: '80px', paddingLeft: '20px', paddingRight: '20px', textAlign: 'center', marginTop: '-86px'}}>
        <div className="container">
          <h1 style={{fontSize: '3rem', color: 'white', marginBottom: '1rem', fontWeight: '700'}}>Terms and Conditions</h1>
          <p style={{fontSize: '1.1rem', color: 'rgba(255, 255, 255, 0.9)'}}>Last Updated: 2 December 2025</p>
        </div>
      </section>

      {/* Terms Content */}
      <div className="terms-container" style={{maxWidth: '1200px', margin: '0 auto', padding: '80px 100px', background: 'white'}}>
        <Link to="/" style={{display: 'inline-flex', alignItems: 'center', color: '#dc2626', textDecoration: 'none', fontWeight: '600', marginBottom: '2rem'}}>← Back to Home</Link>

        <div style={{padding: '0 60px'}}>
          <div style={{background: '#f8f9fa', padding: '25px 30px', borderRadius: '0', marginBottom: '40px', border: 'none', borderLeft: '4px solid #dc2626'}}>
            <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Effective Date:</strong> 2 December 2025</p>
            <p style={{marginBottom: '0', color: '#374151', fontSize: '0.95rem'}}><strong>Owned and operated by:</strong> Castleview Resources Ltd, Company No. 760626, Ireland ("PlayBack Token", "we", "our", or "us").</p>
          </div>

          <h2 style={h2Style}>1. Introduction</h2>
          <p style={pStyle}>
            PlayBack Token ("the Platform") is a digital verification system that records and tokenizes volunteer hours contributed by sports clubs, community organizations, NGOs, and charitable bodies ("Clubs").
          </p>
          <p style={pStyle}>
            The Platform creates blockchain-verified records of volunteer contributions, enabling Companies and Supporters to purchase verified volunteer hours as part of their Environmental, Social, and Governance ("ESG") or Corporate Social Responsibility ("CSR") initiatives.
          </p>
          <p style={pStyle}>
            By accessing or using the Platform, whether as a Club, Volunteer, Company, or Supporter, you agree to be bound by these Terms and Conditions. If you do not agree, you must not use the Platform.
          </p>
          <p style={pStyle}>
            These Terms apply to users worldwide, including but not limited to users in Ireland, the United Kingdom, India, Southeast Asia, the European Union, and other jurisdictions where the Platform operates.
          </p>

          <h2 style={h2Style}>2. Definitions</h2>
          <p style={pStyle}><strong>"Club"</strong> means any sports club, community organization, NGO, charity, or similar body registered on the Platform to log volunteer hours.</p>
          <p style={pStyle}><strong>"Volunteer"</strong> means an individual who contributes unpaid time to a Club and logs those hours on the Platform.</p>
          <p style={pStyle}><strong>"Supervisor"</strong> means an authorized representative of a Club responsible for verifying and approving volunteer hour submissions.</p>
          <p style={pStyle}><strong>"Company"</strong> or <strong>"Customer"</strong> means a business, corporation, or organization that purchases verified volunteer hours through the Platform.</p>
          <p style={pStyle}><strong>"Supporter"</strong> means any individual or entity that purchases verified volunteer hours.</p>
          <p style={pStyle}><strong>"Token"</strong> or <strong>"Soulbound Token"</strong> means a non-transferable, non-tradable digital record minted on the blockchain representing verified volunteer hours. Tokens have no monetary value and cannot be exchanged, sold, or redeemed.</p>
          <p style={pStyle}><strong>"Platform"</strong> means the PlayBack Token website, mobile applications, APIs, and all related services operated by Castleview Resources Ltd.</p>

          <h2 style={h2Style}>3. Nature of Soulbound Tokens</h2>
          
          <h3 style={h3Style}>3.1 What Tokens Are</h3>
          <p style={pStyle}>Soulbound Tokens are permanent, immutable digital records stored on the Polygon blockchain. They serve as verifiable proof that volunteer hours were:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Logged by a Volunteer;</li>
            <li style={liStyle}>Verified by a Supervisor;</li>
            <li style={liStyle}>Approved by the Platform; and</li>
            <li style={liStyle}>Purchased by a Company or Supporter.</li>
          </ul>

          <h3 style={h3Style}>3.2 What Tokens Are NOT</h3>
          <p style={pStyle}><strong>Tokens are NOT:</strong></p>
          <ul style={ulStyle}>
            <li style={liStyle}>Financial instruments, securities, or investments;</li>
            <li style={liStyle}>Cryptocurrency or digital currency;</li>
            <li style={liStyle}>Tradable or transferable assets;</li>
            <li style={liStyle}>Redeemable for cash, goods, or services;</li>
            <li style={liStyle}>Property that can be owned, sold, or exchanged;</li>
            <li style={liStyle}>Speculative assets with potential for appreciation; or</li>
            <li style={liStyle}>Tokens with any intrinsic or market value.</li>
          </ul>

          <h3 style={h3Style}>3.3 No Monetary Value</h3>
          <p style={pStyle}>
            <strong>Tokens have no monetary value whatsoever.</strong> The payment made by Companies or Supporters is a contribution to support community organizations. It is not a purchase of an asset. The Token is merely a digital receipt and verification record.
          </p>

          <h3 style={h3Style}>3.4 Non-Transferability</h3>
          <p style={pStyle}>Once minted, Tokens are permanently bound to the purchasing Company or Supporter's account. They cannot be:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Transferred to another party;</li>
            <li style={liStyle}>Sold on any marketplace;</li>
            <li style={liStyle}>Exchanged for other tokens or assets;</li>
            <li style={liStyle}>Used as collateral; or</li>
            <li style={liStyle}>Inherited or assigned.</li>
          </ul>

          <h3 style={h3Style}>3.5 Verification Purpose Only</h3>
          <p style={pStyle}>Tokens exist solely to provide transparent, immutable proof of:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>The volunteer work that was performed;</li>
            <li style={liStyle}>The Club that organized the volunteer activity;</li>
            <li style={liStyle}>The Company or Supporter that funded the community contribution; and</li>
            <li style={liStyle}>The date and nature of the volunteer activity.</li>
          </ul>

          <h2 style={h2Style}>4. Eligibility Requirements</h2>
          
          <h3 style={h3Style}>4.1 Clubs</h3>
          <p style={pStyle}>To register and participate on the Platform, Clubs must:</p>
          <p style={pStyle}><strong>a) Legal Status (one of the following):</strong></p>
          <ul style={ulStyle}>
            <li style={liStyle}>Be a registered charity or non-profit organization in their jurisdiction;</li>
            <li style={liStyle}>Be affiliated with a recognized sporting or community body;</li>
            <li style={liStyle}>Be a registered society, trust, or similar legal entity; or</li>
            <li style={liStyle}>Provide evidence of legitimate community activities for a minimum of 2 years.</li>
          </ul>

          <p style={pStyle}><strong>b) Verification Requirements:</strong></p>
          <ul style={ulStyle}>
            <li style={liStyle}>Provide accurate organizational details;</li>
            <li style={liStyle}>Submit valid banking or payment information;</li>
            <li style={liStyle}>Designate at least one authorized Supervisor;</li>
            <li style={liStyle}>Maintain accurate records of volunteer activities; and</li>
            <li style={liStyle}>Cooperate with verification and audit requests.</li>
          </ul>

          <p style={pStyle}><strong>c) Ongoing Compliance:</strong></p>
          <ul style={ulStyle}>
            <li style={liStyle}>Submit to periodic verification reviews;</li>
            <li style={liStyle}>Maintain good standing with regulatory bodies;</li>
            <li style={liStyle}>Report any material changes to organizational status; and</li>
            <li style={liStyle}>Comply with all applicable laws in their jurisdiction.</li>
          </ul>

          <h3 style={h3Style}>4.2 Volunteers</h3>
          <p style={pStyle}>Volunteers must:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Be at least 16 years of age (or the minimum legal age for volunteer work in their jurisdiction);</li>
            <li style={liStyle}>Be associated with a registered Club;</li>
            <li style={liStyle}>Log hours honestly and accurately;</li>
            <li style={liStyle}>Provide truthful information about activities performed; and</li>
            <li style={liStyle}>Consent to their volunteer data being recorded on the blockchain.</li>
          </ul>

          <h3 style={h3Style}>4.3 Companies and Supporters</h3>
          <p style={pStyle}>Companies and Supporters must:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Provide accurate business or personal information;</li>
            <li style={liStyle}>Use valid payment methods;</li>
            <li style={liStyle}>Acknowledge that Tokens have no monetary value;</li>
            <li style={liStyle}>Agree not to attempt to resell or transfer Tokens; and</li>
            <li style={liStyle}>Use ESG reports and Token data only for legitimate purposes.</li>
          </ul>

          <h2 style={h2Style}>5. How the Platform Works</h2>
          
          <h3 style={h3Style}>5.1 Volunteer Hour Logging</h3>
          <ol style={{...ulStyle, listStyleType: 'decimal'}}>
            <li style={liStyle}>Volunteers log their hours through the Platform, providing details of date, time, activity type, and description.</li>
            <li style={liStyle}>Supervisors review and approve (or reject) volunteer hour submissions.</li>
            <li style={liStyle}>Platform administrators conduct final verification.</li>
            <li style={liStyle}>Approved hours become available for bundling and purchase.</li>
          </ol>

          <h3 style={h3Style}>5.2 Bundle Creation and Purchase</h3>
          <ol style={{...ulStyle, listStyleType: 'decimal'}}>
            <li style={liStyle}>Approved hours are grouped into bundles based on location, activity type, or other criteria.</li>
            <li style={liStyle}>Bundles are listed on the marketplace with transparent pricing.</li>
            <li style={liStyle}>Companies or Supporters purchase bundles via secure payment processing.</li>
            <li style={liStyle}>Upon successful payment, Tokens are minted on the blockchain.</li>
          </ol>

          <h3 style={h3Style}>5.3 ESG Reporting</h3>
          <ol style={{...ulStyle, listStyleType: 'decimal'}}>
            <li style={liStyle}>After purchase, comprehensive ESG reports are automatically generated.</li>
            <li style={liStyle}>Reports include impact metrics, activity breakdowns, and blockchain verification.</li>
            <li style={liStyle}>Companies can download and use reports for ESG compliance and stakeholder communications.</li>
          </ol>

          <h2 style={h2Style}>6. Payments, Fees, and Distribution</h2>
          
          <h3 style={h3Style}>6.1 Payment Processing</h3>
          <p style={pStyle}>
            All payments are processed by Stripe, Inc. or other authorized third-party payment processors. By making a payment, you agree to the payment processor's terms of service.
          </p>
          <p style={pStyle}>
            Payments may be made in EUR, GBP, USD, INR, or other currencies as supported by the Platform.
          </p>

          <h3 style={h3Style}>6.2 Revenue Distribution</h3>
          <p style={pStyle}>When a Company or Supporter makes a purchase:</p>
          <ul style={ulStyle}>
            <li style={liStyle}><strong>90% of the payment</strong> is transferred to the participating Club(s), distributed proportionally based on the volunteer hours contributed to the bundle.</li>
            <li style={liStyle}><strong>10% of the payment</strong> is retained by PlayBack Token as a platform fee.</li>
          </ul>

          <h3 style={h3Style}>6.3 Club Payments</h3>
          <p style={pStyle}>Club payments are processed to the bank account or payment method registered during onboarding. Clubs are responsible for:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Providing accurate banking information;</li>
            <li style={liStyle}>Ensuring compliance with local tax and regulatory requirements;</li>
            <li style={liStyle}>Issuing receipts or invoices as required by their jurisdiction; and</li>
            <li style={liStyle}>Reporting income in accordance with applicable laws.</li>
          </ul>

          <h3 style={h3Style}>6.4 Taxes</h3>
          <p style={pStyle}>All payments are exclusive of applicable taxes unless otherwise stated.</p>
          <ul style={ulStyle}>
            <li style={liStyle}><strong>Clubs</strong> are responsible for any income tax, GST, VAT, or other taxes applicable in their jurisdiction.</li>
            <li style={liStyle}><strong>Companies</strong> may be subject to withholding tax or other obligations depending on their jurisdiction.</li>
            <li style={liStyle}><strong>PlayBack Token</strong> will provide necessary documentation for tax purposes upon request.</li>
          </ul>

          <h3 style={h3Style}>6.5 No Guaranteed Income</h3>
          <p style={pStyle}>
            PlayBack Token does not guarantee that Clubs will receive any funds. Token purchases are entirely voluntary and depend on Company and Supporter demand. Clubs should not rely on Platform income as their primary funding source.
          </p>

          <h3 style={h3Style}>6.6 Currency and Exchange</h3>
          <p style={pStyle}>
            Payments and distributions may be subject to currency conversion. Exchange rates are determined by our payment processors at the time of transaction. PlayBack Token is not responsible for exchange rate fluctuations.
          </p>

          <h2 style={h2Style}>7. Receipts, Invoices, and Documentation</h2>
          
          <h3 style={h3Style}>7.1 For Companies and Supporters</h3>
          <p style={pStyle}>PlayBack Token issues:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Transaction confirmations and receipts;</li>
            <li style={liStyle}>ESG compliance reports;</li>
            <li style={liStyle}>Blockchain verification certificates; and</li>
            <li style={liStyle}>Tax documentation upon request.</li>
          </ul>

          <h3 style={h3Style}>7.2 For Clubs</h3>
          <p style={pStyle}>
            Clubs may issue receipts for the 90% portion received, in compliance with their national regulations. Donation receipts (for tax deduction purposes) may only be issued by Clubs that are registered charities authorized to provide such receipts.
          </p>

          <h3 style={h3Style}>7.3 Platform Fees</h3>
          <p style={pStyle}>
            Platform fees are invoiced directly by Castleview Resources Ltd. VAT registration number and invoices will be provided where applicable.
          </p>

          <h2 style={h2Style}>8. Club Responsibilities</h2>
          
          <h3 style={h3Style}>8.1 Accurate Record-Keeping</h3>
          <p style={pStyle}>Clubs must:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Maintain accurate records of volunteer activities;</li>
            <li style={liStyle}>Ensure Supervisors verify hours in good faith;</li>
            <li style={liStyle}>Retain supporting documentation for at least 3 years; and</li>
            <li style={liStyle}>Make records available for audit upon reasonable request.</li>
          </ul>

          <h3 style={h3Style}>8.2 Acknowledgment of Support</h3>
          <p style={pStyle}>Clubs that receive funds through PlayBack Token agree to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Display appropriate acknowledgment of PlayBack Token support at their premises or on their website; and</li>
            <li style={liStyle}>Periodically acknowledge support on official social media channels.</li>
          </ul>

          <h3 style={h3Style}>8.3 Compliance with Laws</h3>
          <p style={pStyle}>Clubs must comply with all applicable laws in their jurisdiction, including but not limited to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Charitable registration and reporting requirements;</li>
            <li style={liStyle}>Tax obligations;</li>
            <li style={liStyle}>Data protection and privacy laws;</li>
            <li style={liStyle}>Employment and volunteer regulations; and</li>
            <li style={liStyle}>Anti-money laundering requirements.</li>
          </ul>

          <h2 style={h2Style}>9. Volunteer Rights and Responsibilities</h2>
          
          <h3 style={h3Style}>9.1 Honest Reporting</h3>
          <p style={pStyle}>
            Volunteers must log hours honestly and accurately. Falsifying volunteer records is grounds for immediate removal from the Platform and may result in legal action.
          </p>

          <h3 style={h3Style}>9.2 Privacy</h3>
          <p style={pStyle}>
            Volunteer names and basic activity information are recorded on the blockchain as part of the verification process. Volunteers consent to this limited disclosure when registering on the Platform.
          </p>
          <p style={pStyle}>
            Volunteer personal contact information is never shared with Companies without explicit consent.
          </p>

          <h3 style={h3Style}>9.3 Recognition</h3>
          <p style={pStyle}>
            Volunteers can view which Companies have purchased their tokenized hours, providing recognition for their community contributions.
          </p>

          <h2 style={h2Style}>10. Company and Supporter Obligations</h2>
          
          <h3 style={h3Style}>10.1 Legitimate Use</h3>
          <p style={pStyle}>Companies and Supporters agree to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Use purchased Tokens and ESG reports only for legitimate business purposes;</li>
            <li style={liStyle}>Not misrepresent the nature or scope of their community support;</li>
            <li style={liStyle}>Not attempt to resell, transfer, or trade Tokens; and</li>
            <li style={liStyle}>Report any suspected fraud or irregularities.</li>
          </ul>

          <h3 style={h3Style}>10.2 ESG Claims</h3>
          <p style={pStyle}>Companies are responsible for ensuring that any ESG claims made based on Token purchases are accurate and compliant with applicable regulations, including but not limited to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>EU Corporate Sustainability Reporting Directive (CSRD);</li>
            <li style={liStyle}>India's Business Responsibility and Sustainability Reporting (BRSR);</li>
            <li style={liStyle}>UK Streamlined Energy and Carbon Reporting (SECR);</li>
            <li style={liStyle}>US SEC Climate Disclosure rules; and</li>
            <li style={liStyle}>Other applicable ESG reporting frameworks.</li>
          </ul>
          <p style={pStyle}>
            PlayBack Token provides verification data but does not provide legal, accounting, or compliance advice.
          </p>

          <h2 style={h2Style}>11. Fraud Prevention and Disputes</h2>
          
          <h3 style={h3Style}>11.1 Fraud Detection</h3>
          <p style={pStyle}>PlayBack Token employs verification procedures to detect and prevent fraud. This includes:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Club application review and approval;</li>
            <li style={liStyle}>Multi-tier hour approval process;</li>
            <li style={liStyle}>Periodic audits and spot checks; and</li>
            <li style={liStyle}>Blockchain-based immutable record-keeping.</li>
          </ul>

          <h3 style={h3Style}>11.2 Reporting Fraud</h3>
          <p style={pStyle}>
            Users who suspect fraud or misrepresentation should report it immediately to info@playbacktoken.com. All reports are investigated promptly.
          </p>

          <h3 style={h3Style}>11.3 Consequences of Fraud</h3>
          <p style={pStyle}>In cases of proven fraud or misrepresentation:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Clubs may be suspended or permanently removed from the Platform;</li>
            <li style={liStyle}>Funds may be withheld or recovered;</li>
            <li style={liStyle}>User accounts may be terminated;</li>
            <li style={liStyle}>Legal action may be pursued; and</li>
            <li style={liStyle}>Relevant authorities may be notified.</li>
          </ul>

          <h3 style={h3Style}>11.4 Payment Disputes</h3>
          <p style={pStyle}>If a Company or Supporter raises a dispute or chargeback:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>PlayBack Token will cooperate with the payment processor's dispute resolution process;</li>
            <li style={liStyle}>Club payments may be delayed or reversed pending resolution;</li>
            <li style={liStyle}>Documentation may be required from all parties; and</li>
            <li style={liStyle}>Decisions by the payment processor are generally final.</li>
          </ul>

          <h3 style={h3Style}>11.5 Limitation of Liability</h3>
          <p style={pStyle}>
            Castleview Resources Ltd is not liable for fraudulent acts of Clubs, Volunteers, Companies, or third parties. Users engage with the Platform at their own risk.
          </p>

          <h2 style={h2Style}>12. Data Protection and Privacy</h2>
          
          <h3 style={h3Style}>12.1 Applicable Laws</h3>
          <p style={pStyle}>PlayBack Token complies with applicable data protection laws, including:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>EU General Data Protection Regulation (GDPR);</li>
            <li style={liStyle}>UK Data Protection Act 2018;</li>
            <li style={liStyle}>India's Digital Personal Data Protection Act 2023;</li>
            <li style={liStyle}>Other applicable privacy laws in jurisdictions where we operate.</li>
          </ul>

          <h3 style={h3Style}>12.2 Data Collection</h3>
          <p style={pStyle}>We collect only data necessary for:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Account creation and verification;</li>
            <li style={liStyle}>Payment processing;</li>
            <li style={liStyle}>Volunteer hour recording and verification;</li>
            <li style={liStyle}>ESG report generation;</li>
            <li style={liStyle}>Legal and regulatory compliance; and</li>
            <li style={liStyle}>Platform improvement and analytics.</li>
          </ul>

          <h3 style={h3Style}>12.3 Data Sharing</h3>
          <p style={pStyle}>
            Personal data is never sold or shared for marketing purposes without explicit consent.
          </p>
          <p style={pStyle}>Data may be shared with:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Payment processors (Stripe) for transaction processing;</li>
            <li style={liStyle}>Blockchain networks for Token minting;</li>
            <li style={liStyle}>Regulatory authorities when legally required; and</li>
            <li style={liStyle}>Third-party service providers under appropriate data protection agreements.</li>
          </ul>

          <h3 style={h3Style}>12.4 Blockchain Data</h3>
          <p style={pStyle}>
            Certain data (volunteer names, Club names, activity descriptions, dates, and hours) is permanently recorded on the public blockchain. This data cannot be deleted or modified once minted. By using the Platform, you consent to this permanent record.
          </p>

          <h3 style={h3Style}>12.5 Data Subject Rights</h3>
          <p style={pStyle}>Users have rights under applicable law to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Access their personal data;</li>
            <li style={liStyle}>Correct inaccurate data;</li>
            <li style={liStyle}>Request deletion (subject to legal and technical limitations);</li>
            <li style={liStyle}>Object to certain processing;</li>
            <li style={liStyle}>Data portability; and</li>
            <li style={liStyle}>Withdraw consent.</li>
          </ul>
          <p style={pStyle}>
            For data requests, contact info@playbacktoken.com.
          </p>
          <p style={pStyle}>
            For complete details, refer to our Privacy Policy at www.playbacktoken.com/privacy.
          </p>

          <h2 style={h2Style}>13. Intellectual Property</h2>
          
          <h3 style={h3Style}>13.1 Platform Ownership</h3>
          <p style={pStyle}>
            All content, software, trademarks, logos, and materials on the Platform are the property of Castleview Resources Ltd and are protected by intellectual property laws.
          </p>

          <h3 style={h3Style}>13.2 Limited License</h3>
          <p style={pStyle}>Users are granted a limited, non-exclusive, non-transferable license to use the Platform for its intended purposes. This license does not include the right to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Copy, modify, or distribute Platform content;</li>
            <li style={liStyle}>Reverse engineer or decompile Platform software;</li>
            <li style={liStyle}>Use trademarks without permission;</li>
            <li style={liStyle}>Create derivative works; or</li>
            <li style={liStyle}>Sublicense access to others.</li>
          </ul>

          <h3 style={h3Style}>13.3 User Content</h3>
          <p style={pStyle}>
            Users retain ownership of content they submit (such as Club logos, volunteer descriptions) but grant PlayBack Token a perpetual, royalty-free license to use such content for Platform operations, marketing, and ESG reporting.
          </p>

          <h2 style={h2Style}>14. Disclaimers and Limitation of Liability</h2>
          
          <h3 style={h3Style}>14.1 Platform Provided "As Is"</h3>
          <p style={pStyle}>
            The Platform is provided "as is" and "as available" without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.
          </p>

          <h3 style={h3Style}>14.2 No Guarantee of Availability</h3>
          <p style={pStyle}>PlayBack Token does not guarantee that the Platform will be:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Available at all times;</li>
            <li style={liStyle}>Free from errors or interruptions;</li>
            <li style={liStyle}>Secure from all threats; or</li>
            <li style={liStyle}>Compatible with all devices or systems.</li>
          </ul>

          <h3 style={h3Style}>14.3 Blockchain Risks</h3>
          <p style={pStyle}>Users acknowledge that blockchain technology involves inherent risks, including but not limited to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Network congestion and transaction delays;</li>
            <li style={liStyle}>Smart contract vulnerabilities;</li>
            <li style={liStyle}>Changes in blockchain protocols;</li>
            <li style={liStyle}>Regulatory changes affecting blockchain use; and</li>
            <li style={liStyle}>Technical failures beyond our control.</li>
          </ul>

          <h3 style={h3Style}>14.4 Limitation of Liability</h3>
          <p style={pStyle}>To the maximum extent permitted by law, Castleview Resources Ltd and its officers, directors, employees, and agents shall not be liable for:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Any indirect, incidental, special, consequential, or punitive damages;</li>
            <li style={liStyle}>Loss of profits, revenue, data, or business opportunities;</li>
            <li style={liStyle}>Damages arising from reliance on Platform data;</li>
            <li style={liStyle}>Damages resulting from unauthorized access;</li>
            <li style={liStyle}>Damages caused by third parties; or</li>
            <li style={liStyle}>Damages exceeding the amount paid by the user in the preceding 12 months.</li>
          </ul>

          <h3 style={h3Style}>14.5 Indemnification</h3>
          <p style={pStyle}>Users agree to indemnify and hold harmless Castleview Resources Ltd from any claims, damages, losses, or expenses arising from:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Violation of these Terms;</li>
            <li style={liStyle}>Misuse of the Platform;</li>
            <li style={liStyle}>Fraudulent or illegal activity;</li>
            <li style={liStyle}>Infringement of third-party rights; or</li>
            <li style={liStyle}>Inaccurate information provided.</li>
          </ul>

          <h2 style={h2Style}>15. Termination and Suspension</h2>
          
          <h3 style={h3Style}>15.1 Termination by Users</h3>
          <p style={pStyle}>Users may terminate their accounts at any time by contacting info@playbacktoken.com. Termination does not affect:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Tokens already minted (which remain on the blockchain);</li>
            <li style={liStyle}>Payments already processed; or</li>
            <li style={liStyle}>Data already recorded on the blockchain.</li>
          </ul>

          <h3 style={h3Style}>15.2 Termination by PlayBack Token</h3>
          <p style={pStyle}>PlayBack Token may suspend or terminate access to the Platform at any time, with or without notice, for reasons including but not limited to:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Breach of these Terms;</li>
            <li style={liStyle}>Fraudulent or illegal activity;</li>
            <li style={liStyle}>Inactivity for extended periods;</li>
            <li style={liStyle}>Non-payment of fees;</li>
            <li style={liStyle}>Platform discontinuation; or</li>
            <li style={liStyle}>Any reason deemed necessary for Platform integrity.</li>
          </ul>

          <h3 style={h3Style}>15.3 Effect of Termination</h3>
          <p style={pStyle}>Upon termination:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Access to the Platform is revoked;</li>
            <li style={liStyle}>Pending payments may be forfeited;</li>
            <li style={liStyle}>Data may be retained as required by law; and</li>
            <li style={liStyle}>Blockchain records remain permanent.</li>
          </ul>

          <h2 style={h2Style}>16. Dispute Resolution</h2>
          
          <h3 style={h3Style}>16.1 Informal Resolution</h3>
          <p style={pStyle}>
            Before initiating formal proceedings, parties agree to attempt to resolve disputes informally by contacting info@playbacktoken.com. We will respond within 14 business days.
          </p>

          <h3 style={h3Style}>16.2 Governing Law</h3>
          <p style={pStyle}>
            These Terms are governed by and construed in accordance with the laws of Ireland, without regard to conflict of law principles.
          </p>

          <h3 style={h3Style}>16.3 Jurisdiction</h3>
          <p style={pStyle}>
            For users in the European Union, United Kingdom, and other jurisdictions where exclusive jurisdiction clauses are not enforceable, disputes may be brought in the courts of the user's country of residence.
          </p>
          <p style={pStyle}>
            For all other users, disputes shall be subject to the exclusive jurisdiction of the courts of Ireland.
          </p>

          <h3 style={h3Style}>16.4 Alternative Dispute Resolution</h3>
          <p style={pStyle}>
            Users in the European Union may use the EU Online Dispute Resolution platform at https://ec.europa.eu/consumers/odr/.
          </p>
          <p style={pStyle}>
            Users in India may seek resolution through consumer forums or other dispute resolution mechanisms as provided under Indian law.
          </p>

          <h2 style={h2Style}>17. International Users</h2>
          
          <h3 style={h3Style}>17.1 Global Availability</h3>
          <p style={pStyle}>
            The Platform is available to users worldwide, subject to compliance with local laws and these Terms.
          </p>

          <h3 style={h3Style}>17.2 Local Compliance</h3>
          <p style={pStyle}>Users are responsible for complying with all laws applicable in their jurisdiction, including:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Charitable and non-profit regulations;</li>
            <li style={liStyle}>Tax and reporting requirements;</li>
            <li style={liStyle}>Data protection laws;</li>
            <li style={liStyle}>Foreign exchange controls;</li>
            <li style={liStyle}>Anti-money laundering laws; and</li>
            <li style={liStyle}>Consumer protection regulations.</li>
          </ul>

          <h3 style={h3Style}>17.3 India-Specific Provisions</h3>
          <p style={pStyle}>For users in India:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>GST applies to platform fees where applicable;</li>
            <li style={liStyle}>Clubs registered under the Foreign Contribution Regulation Act (FCRA) must ensure compliance when receiving foreign contributions;</li>
            <li style={liStyle}>Companies may use Token purchases for CSR compliance under Section 135 of the Companies Act 2013, subject to their own CSR policy and applicable rules; and</li>
            <li style={liStyle}>Data processing complies with the Digital Personal Data Protection Act 2023.</li>
          </ul>

          <h3 style={h3Style}>17.4 United Kingdom Provisions</h3>
          <p style={pStyle}>For users in the United Kingdom:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>UK GDPR applies to data processing;</li>
            <li style={liStyle}>Charities must comply with Charity Commission requirements; and</li>
            <li style={liStyle}>Companies may use Token purchases for ESG reporting purposes.</li>
          </ul>

          <h3 style={h3Style}>17.5 United States Provisions</h3>
          <p style={pStyle}>For users in the United States:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Tokens are not securities under US law;</li>
            <li style={liStyle}>Payments may be subject to 1099 reporting for Clubs;</li>
            <li style={liStyle}>State-specific nonprofit regulations apply; and</li>
            <li style={liStyle}>CCPA rights apply to California residents.</li>
          </ul>

          <h2 style={h2Style}>18. Modifications to Terms</h2>
          
          <h3 style={h3Style}>18.1 Right to Modify</h3>
          <p style={pStyle}>PlayBack Token reserves the right to modify these Terms at any time. Material changes will be notified via:</p>
          <ul style={ulStyle}>
            <li style={liStyle}>Email to registered users;</li>
            <li style={liStyle}>Notice on the Platform; or</li>
            <li style={liStyle}>Other reasonable means.</li>
          </ul>

          <h3 style={h3Style}>18.2 Acceptance of Changes</h3>
          <p style={pStyle}>
            Continued use of the Platform after changes take effect constitutes acceptance of the modified Terms. If you do not agree to changes, you must stop using the Platform.
          </p>

          <h3 style={h3Style}>18.3 Version History</h3>
          <p style={pStyle}>
            The effective date at the top of this document indicates when these Terms were last updated.
          </p>

          <h2 style={h2Style}>19. Miscellaneous</h2>
          
          <h3 style={h3Style}>19.1 Entire Agreement</h3>
          <p style={pStyle}>
            These Terms, together with the Privacy Policy and any other policies referenced herein, constitute the entire agreement between users and PlayBack Token.
          </p>

          <h3 style={h3Style}>19.2 Severability</h3>
          <p style={pStyle}>
            If any provision of these Terms is found to be unenforceable, the remaining provisions shall continue in full force and effect.
          </p>

          <h3 style={h3Style}>19.3 Waiver</h3>
          <p style={pStyle}>
            Failure to enforce any provision does not constitute a waiver of that or any other provision.
          </p>

          <h3 style={h3Style}>19.4 Assignment</h3>
          <p style={pStyle}>
            Users may not assign their rights or obligations under these Terms. PlayBack Token may assign its rights and obligations to any successor or affiliate.
          </p>

          <h3 style={h3Style}>19.5 Force Majeure</h3>
          <p style={pStyle}>
            PlayBack Token is not liable for delays or failures resulting from circumstances beyond its reasonable control, including natural disasters, war, terrorism, labor disputes, government actions, or internet or blockchain outages.
          </p>

          <h3 style={h3Style}>19.6 Language</h3>
          <p style={pStyle}>
            These Terms are provided in English. In the event of any conflict between translated versions and the English version, the English version prevails.
          </p>

          <div style={{marginTop: '4rem', paddingTop: '2rem', borderTop: '2px solid #e5e7eb'}}>
            <h2 style={h2Style}>20. Contact Information</h2>
            <div style={{background: '#f8f9fa', padding: '25px 30px', borderRadius: '8px', marginTop: '1rem'}}>
              <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Castleview Resources Ltd</strong></p>
              <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}>Registered in Ireland – Company No. 760626</p>
              <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Email:</strong> info@playbacktoken.com</p>
              <p style={{marginBottom: '0.5rem', color: '#374151', fontSize: '0.95rem'}}><strong>Website:</strong> www.playbacktoken.com</p>
              <p style={{marginBottom: '0', color: '#374151', fontSize: '0.95rem'}}>
                <strong>Mailing Address:</strong><br/>
                Unit 3 Grange Road Retail Park, Grange Road, Rathfarnham<br/>
                Dublin 16, D16 XD82, Ireland
              </p>
            </div>
          </div>

          <div style={{marginTop: '3rem', padding: '25px', background: '#fef2f2', border: '2px solid #fecaca', borderRadius: '8px'}}>
            <h2 style={h2Style}>21. Acknowledgment</h2>
            <p style={pStyle}>By using the PlayBack Token Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
            <p style={pStyle}>You specifically acknowledge and understand that:</p>
            <ol style={{...ulStyle, listStyleType: 'decimal'}}>
              <li style={liStyle}><strong>Tokens have no monetary value</strong> and cannot be sold, traded, or redeemed;</li>
              <li style={liStyle}><strong>Tokens are permanent blockchain records</strong> and cannot be deleted;</li>
              <li style={liStyle}><strong>Platform income is not guaranteed</strong> for Clubs;</li>
              <li style={liStyle}><strong>You are responsible for compliance</strong> with laws in your jurisdiction; and</li>
              <li style={liStyle}><strong>Disputes are governed by Irish law</strong> (subject to local consumer protection rules).</li>
            </ol>
          </div>

          <p style={{...pStyle, textAlign: 'center', marginTop: '3rem', fontSize: '0.85rem', color: '#9ca3af'}}>
            © 2025 Castleview Resources Ltd. All rights reserved.<br/>
            Last Updated: 2 December 2025
          </p>
        </div>
      </div>
    </MarketingLayout>
  );
};

export default TermsPage;
